import auth_required from './hooks/auth_required';
import preloaderHook from './hooks/preloader-hook';

import NotFoundPage from '@/views/pages/404.vue';
import Home from '@/views/Home.vue';
import Storybook from '@/views/Storybook.vue';
import Report from '@/views/Report.vue';

import multiguard from 'vue-router-multiguard';

import Vue from 'vue';
import { RouterMode } from 'vue-router';

import desktopViewForced from '@/routes/hooks/desktop-view-forced';
import config from '@/config';

const { storybookEnabled } = config;

const mode = process.env.VUE_APP_CONFIG_ROUTING_MODE as RouterMode || 'history';

const filtersHook = (to: any, from: any, next: Function) => {
  Vue.prototype.$filter.set();
  next();
};

const hashHook = (to: any, from: any, next: Function) => {
  if(mode === 'history' && to.hash) {
    if(to.hash.includes('login/member')) {
      const index = to.hash.indexOf('login/member');
      next(to.hash.slice(index));
    } else {
      next();
    }
  } else {
    next();
  }
};

const referralHook = (to: any, from: any, next: Function) => {
  if (to.query.ref) {
    Vue.cookies.set('referralId', to.query.ref);
    next('/register');
  } else {
    next();
  }
};

const storybookCheck = (to, from, next) => {
  if (storybookEnabled) {
    next()
  }

  next(false)
}

export default [
  {
    path: '',
    name: 'app.blank',
    beforeEnter: multiguard([auth_required, hashHook, filtersHook, preloaderHook, referralHook, desktopViewForced]),
    //@ts-ignore
    component: Home,
    meta: {
      menuType: 'dashboard',
      pageTitle: 'Home'
    }
  },
  {
    path: '/app/storybook',
    name: 'app.storybook',
    beforeEnter: storybookCheck,
    // beforeEnter: multiguard([auth_required, hashHook, filtersHook, preloaderHook, referralHook, desktopViewForced]),
    //@ts-ignore
    component: Storybook,
    meta: {
      menuType: 'storybook',
      pageTitle: 'Storybook'
    }
  },
  {
    path: '/app/dashboard/:data',
    name: 'app.index',
    beforeEnter: multiguard([auth_required, preloaderHook, desktopViewForced]),
    //@ts-ignore
    component: Home,
    meta: {
      menuType: 'dashboard',
      pageTitle: 'Home'
    }
  },
  {
    path: '/app/report/:type/:data/:report?',
    name: 'app.report',
    beforeEnter: multiguard([auth_required, filtersHook, desktopViewForced]),
    afterEnter: preloaderHook,
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report'
    }
  },
  // {
  //   path: '/app/sixth-sense/:data',
  //   name: 'app.sixth_sense',
  //   beforeEnter: auth_required,
  //   //@ts-ignore
  //   component: SixthSense
  // },
  {
    path: '/app/conversions/:data/:report?',
    name: 'app.conversions',
    beforeEnter: multiguard([auth_required, filtersHook, desktopViewForced]),
    afterEnter: preloaderHook,
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report conversions'
    }
  },
  {
    path: '/app/postbacks/:data/:report?',
    name: 'app.postbacks',
    beforeEnter: multiguard([auth_required, filtersHook, desktopViewForced]),
    afterEnter: preloaderHook,
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report postbacks'
    }
  },
  {
    path: '/app/live-visits/:data/:report?',
    name: 'app.live-visits',
    beforeEnter: multiguard([auth_required, filtersHook, desktopViewForced]),
    afterEnter: preloaderHook,
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report live visits'
    }
  },
  {
    path: '/app/live-clicks/:data/:report?',
    name: 'app.live-clicks',
    beforeEnter: multiguard([auth_required, filtersHook, desktopViewForced]),
    afterEnter: preloaderHook,
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report live clicks'
    }
  },
  {
    path: '/app/errors/:data/:report?',
    name: 'app.errors',
    beforeEnter: multiguard([auth_required, filtersHook, desktopViewForced]),
    afterEnter: preloaderHook,
    //@ts-ignore
    component: Report,
    meta: {
      pageTitle: 'Report errors'
    }
  },
  {
    path: '*',
    name: 'app.not_found',
    beforeEnter: multiguard([auth_required, preloaderHook, desktopViewForced]),
    //@ts-ignore
    component: NotFoundPage,
    meta: {
      notFound: true,
    }
  }
];
